import axiosInstance from "../utils/axios";

class ContactService {
    async getContacts(params) {
        const response = await axiosInstance.post('/api/Contact/GetContacts', params);
        return response.data;
    }

    async getContactById(contactId) {
        const response = await axiosInstance.get('/api/Contact/GetContactById', {
            params: { contactId }
        });
        return response.data;
    }

    async getStreams() {
        const response = await axiosInstance.get('/api/Contact/GetStreams');
        return response.data;
    }

    async getBatches(streamId) {
        const response = await axiosInstance.get('/api/Contact/GetBatches', {
            params: { streamId }
        });
        return response.data;
    }

    async getColleges() {
        const response = await axiosInstance.get('/api/Contact/GetColleges');
        return response.data;
    }

    async getSessions() {
        const response = await axiosInstance.get('/api/Contact/GetSessions');
        return response.data;
    }

    async importContactsToLeads(payload, assignedTo = null) {
        let body;
        if (Array.isArray(payload)) {
            body = { contactIds: payload, assignedTo };
        } else if (payload && typeof payload === 'object') {
            body = payload;
        } else {
            body = { contactIds: [], assignedTo };
        }
        const response = await axiosInstance.post('/api/Contact/ImportToLeads', body);
        return response.data;
    }

    async analyzeContacts(formData) {
        const response = await axiosInstance.post('/api/Contact/analyze/contacts', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    }

    async importContactsFromExcel(payload) {
        const response = await axiosInstance.post('/api/Contact/import/contacts', payload);
        return response.data;
    }
}

export const contactService = new ContactService();
